import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { I18nProvider } from './i18n/index.ts';
import './styles.css';

/**
 * Browser entry for landing-web. Vite compiles this to
 * `dist/assets/main.*.js` and `index.html` pulls it as a module. The
 * app is dependency-light by design: no router, no React Query, no
 * analytics — just React + the i18n context.
 */
const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('landing-web: #root element missing from index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
